export const menuOption = {
    CLEAR:"clear",
    DELETE:"delete",
    BLOCK:'block',
    UNBLOCK:'unblock',
}
export const initialActionState = {
    actionName:"",
    alertMessage:"",
  }
export const actionAlertMessage ={
    [menuOption.CLEAR]:"Are you sure, you want to Clear this conversation?",
    [menuOption.DELETE]:"Are you sure, you want to Delete this chat?",
    [menuOption.BLOCK]:"Are you sure, you want to Block this chat?",
    [menuOption.UNBLOCK]:"Are you sure, you want to Unblock this chat?"
}